// One place for how the two "hide money" settings combine.
//
// hide_financial_data is the merchant-wide PIN setting: anyone signed in can
// reveal the numbers again with the PIN. role_hides_financial_values comes from
// the signed-in system user's role: there is nothing to reveal them with.
export const hidesFinancialValues = attributes =>
  Boolean(attributes?.hide_financial_data || attributes?.role_hides_financial_values)

export const canRevealFinancialValues = attributes =>
  Boolean(attributes?.hide_financial_data && !attributes?.role_hides_financial_values)
